import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import CustomerProtectedRoute from "@/components/CustomerProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/Home";
import Account from "@/pages/Account";
import Schedule from "@/pages/Schedule";
import Book from "@/pages/Book";
import Bundles from "@/pages/Bundles";
import InvoicePay from "@/pages/InvoicePay";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import DashLayout from "@/pages/dashboard/DashLayout";
import Overview from "@/pages/dashboard/Overview";
import DashSchedule from "@/pages/dashboard/DashSchedule";
import Appointments from "@/pages/dashboard/Appointments";
import Clients from "@/pages/dashboard/Clients";
import Invoices from "@/pages/dashboard/Invoices";
import Memberships from "@/pages/dashboard/Bundles";
import Instructors from "@/pages/dashboard/Instructors";
import PaymentsAdmin from "@/pages/dashboard/Payments";
import Reviews from "@/pages/dashboard/Reviews";
import Messaging from "@/pages/dashboard/Messaging";
import Analytics from "@/pages/dashboard/Analytics";
import Security from "@/pages/dashboard/Security";
import Settings from "@/pages/dashboard/Settings";
import Waitlist from "@/pages/dashboard/Waitlist";
import Orders from "@/pages/dashboard/Orders";
import Notifications from "@/pages/dashboard/Notifications";
import Locations from "@/pages/dashboard/Locations";
import Reports from "@/pages/dashboard/Reports";
import Audit from "@/pages/dashboard/Audit";

function AppRouter() {
  const location = useLocation();
  // Synchronous check (not useEffect) so the OAuth session_id is processed before any auth checks run.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/account" element={<CustomerProtectedRoute><Account /></CustomerProtectedRoute>} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/book" element={<Book />} />
              <Route path="/bundles" element={<Bundles />} />
              <Route path="/pay/:invoiceId" element={<InvoicePay />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<ProtectedRoute><DashLayout /></ProtectedRoute>}>
                <Route index element={<Overview />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="schedule" element={<DashSchedule />} />
                <Route path="locations" element={<Locations />} />
                <Route path="appointments" element={<Appointments />} />
                <Route path="waitlist" element={<Waitlist />} />
                <Route path="clients" element={<Clients />} />
                <Route path="instructors" element={<Instructors />} />
                <Route path="orders" element={<Orders />} />
                <Route path="payments" element={<PaymentsAdmin />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="bundles" element={<Memberships />} />
                <Route path="reviews" element={<Reviews />} />
                <Route path="messaging" element={<Messaging />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="reports" element={<Reports />} />
                <Route path="settings" element={<Settings />} />
                <Route path="security" element={<Security />} />
                <Route path="audit" element={<Audit />} />
              </Route>
            </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <CustomerAuthProvider>
              <AppRouter />
              <Toaster position="top-right" richColors />
            </CustomerAuthProvider>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
